import React, { useState, useRef, useEffect, useContext } from "react";
import Axios from "axios";
import axios from "axios";
import moment from "moment";
import { normalizePhone } from "../../../utils";

import { usePersistedState } from "../../../hooks";
import { useLocation } from "react-router-dom";

import AuthContext from "../../../contexts/Auth";
import EmpresaContext from "../../../contexts/Empresa";
import { v1 as uuidv1 } from "uuid";
import api from "../../../services/api";
import NotificationAlert from "react-notification-alert";
import Table from "./Table";
import Kanban from "./Kanban";
import Filters from "./Filters";
import EncaminharOportunidades from "./Encaminhar";
import Encerrar from "./Encerrar/index";
import Reagendar from "./Reagendar/index";
import AlterarEstagio from "./AlterarEstagio";
import Export from "./Export";
import Sumario from "./Sumario";
import RotasVisitas from "./RotasVisitas";
import VisualizarRotas from "./VisualizarRotas";
import ListagemRotas from "./ListagemRotas";
import DetalhesRota from "./DetalhesRota";

// reactstrap components
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  UncontrolledTooltip,
  Card,
  CardBody,
  CardHeader,
  Container,
  Row,
  Col,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Spinner,
  FormGroup,
  Label,
} from "reactstrap";
import Select2 from "react-select2-wrapper";
// core components

import SimpleHeader from "./SimpleHeader";
import Fullcalendar from "../../../components/FullCalendar";
import ChatModal from "./components/chatModal";
import CopilotSidebar from "./components/copilotSidebar";
import CardsSidebar from "./components/cardsSidebar";
import CardModal from "../Pipelines/MeusPipelines/CardModal";
import CardForm from "../Pipelines/MeusPipelines/CardForm";
import OportunidadesForm from "./Form";

let cancelApi = undefined;

export default function Oportunidades({ readOnly = false, ...props }) {
  const { empresaSelecionada } = useContext(EmpresaContext);
  const location = useLocation();
  const { presetId } = location.state || {};
  const { hasPermission, hasRole, user } = useContext(AuthContext);
  const [currentPage, setCurrentPage] = usePersistedState("page", 1);
  const [currentPerPage, setCurrentPerPage] = usePersistedState("perPage", 10);
  const [openChatModal, setOpenChatModal] = useState(false);
  const [openCopilot, setOpenCopilot] = useState(false);
  const [copilotOportunidade, setCopilotOportunidade] = useState(null);
  const [currentSortField, setCurrentSortField] = usePersistedState(
    "sortFieldOportunidade",
    "data_agendamento",
  );
  const [currentSortOrder, setCurrentSortOrder] = usePersistedState(
    "sortOrderOportunidade",
    "desc",
  );
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null);
  const [oportunidades, setOportunidades] = useState([]);
  const [oportunidadesKanban, setOportunidadesKanban] = useState([]);

  const [showConverterModal, setShowConverterModal] = useState(false);
  const [showEncerrarModal, setShowEncerrarModal] = useState(false);
  const [opActionSelected, setOpActionSelected] = useState(null);

  // Card a partir de oportunidade
  const [showCardModalFromOp, setShowCardModalFromOp] = useState(false);
  const [opParaCard, setOpParaCard] = useState(null);
  const [funisPipeline, setFunisPipeline] = useState([]);
  const hasPipeline = funisPipeline.length > 0;
  
  // Cards vinculados a oportunidade
  const [showCardsListModal, setShowCardsListModal] = useState(false);
  const [opParaCards, setOpParaCards] = useState(null);
  const [cardsVinculados, setCardsVinculados] = useState([]);

  const [opChatTelefone, setOpChatTelefone] = useState("");

  // Sidebar de detalhes da oportunidade
  const [showOpDetailsSidebar, setShowOpDetailsSidebar] = useState(false);
  const [selectedOpIdForSidebar, setSelectedOpIdForSidebar] = useState(null);

  // Sidebar de detalhes do card
  const [showCardDetailsSidebar, setShowCardDetailsSidebar] = useState(false);
  const [selectedCardForSidebar, setSelectedCardForSidebar] = useState(null);

  const [encerramentos, setEncerramentos] = useState([]);
  const [encerramentoId, setEncerramentoId] = useState(null);
  const [isActionSaving, setIsActionSaving] = useState(false);

  async function loadEncerramentos() {
    try {
      const response = await api.get(
        `/common/empresas/${empresaSelecionada?.id}/motivos-encerramentos`,
        {
          params: { aplicacoes: ["encerramento", "null"] },
        },
      );
      setEncerramentos(response.data);
    } catch (error) {
      console.log(error);
      if (notify)
        notify("danger", "Não foi possível carregar motivos de encerramentos");
    }
  }

  function handleOpenConverterModal(op) {
    setOpActionSelected(op);
    setShowConverterModal(true);
  }

  function handleOpenEncerrarModal(op) {
    setOpActionSelected(op);
    if (encerramentos.length === 0) {
      loadEncerramentos();
    }
    setShowEncerrarModal(true);
  }

  async function executeConverter() {
    setIsActionSaving(true);
    try {
      await api.put(
        `/marketing/oportunidades/${opActionSelected.id}/converter`,
        {
          user_id: empresaSelecionada?.id,
        },
      );
      if (notify) notify("success", "Oportunidade convertida");
      setShowConverterModal(false);
      setOpActionSelected(null);
      loadOportunidades();
    } catch (error) {
      console.log(error);
      if (notify) notify("danger", "Não foi possível converter a oportunidade");
    }
    setIsActionSaving(false);
  }

  async function executeEncerrar() {
    if (!encerramentoId) return;
    setIsActionSaving(true);
    try {
      await api.post(
        `/common/empresas/${empresaSelecionada?.id}/oportunidades/${opActionSelected.id}/encerrar-oportunidades`,
        {
          motivo_encerramento_id: encerramentoId,
        },
      );
      if (notify) notify("success", "Oportunidade encerrada");
      setShowEncerrarModal(false);
      setEncerramentoId(null);
      setOpActionSelected(null);
      loadOportunidades();
    } catch (error) {
      console.log(error);
      if (notify) notify("danger", "Não foi possível encerrar oportunidade");
    }
    setIsActionSaving(false);
  }

  const [pageProperties, setPageProperties] = useState({
    total: "0",
    perPage: currentPerPage,
    page: currentPage,
    lastPage: 1,
    loading: false,
    sort: new Map([]),
  });
  const [lastSearch, setLastSearch] = usePersistedState(
    "lastSearchOportunidade",
    {},
  );
  const [showEncaminhamento, setShowEncaminhamento] = useState(false);
  const [showEncerramento, setShowEncerramento] = useState(false);
  const [showReagendamento, setShowReagendamento] = useState(false);
  const [showAlterarEstagio, setShowAlterarEstagio] = useState(false);
  const [showExport, setShowExport] = useState(false);
  const [showSumario, setShowSumario] = useState(false);
  const [showRotasVisitas, setShowRotasVisitas] = useState(false);
  const [showVisualizarRotas, setShowVisualizarRotas] = useState(false);
  const [showListagemRotas, setShowListagemRotas] = useState(false);
  const [showDetalhesRota, setShowDetalhesRota] = useState(false);
  const [rotaIdSelecionada, setRotaIdSelecionada] = useState(null);
  const notificationAlert = useRef();
  const [rLanes, setRLanes] = useState([]);
  const [mensagensBaileys, setMensagensBaileys] = useState([]);
  const [baileysPage, setBaileysPage] = useState(1);
  const [hasMoreBaileys, setHasMoreBaileys] = useState(true);
  const [opChatAtual, setOpChatAtual] = useState(null);

  const [visaoMode, setVisaoMode] = useState(
    () => localStorage.getItem("playnee_visao_oportunidades") || "lista",
  );
  const setVisaoModeWithPersist = (mode) => {
    localStorage.setItem("playnee_visao_oportunidades", mode);
    setVisaoMode(mode);
  };
  const [changeVisaoModeStartLoad, setChangeVisaoModeStartLoad] =
    useState(false);

  useEffect(() => {
    async function runLoadCards() {
      if (oportunidadesKanban && oportunidadesKanban.length > 0) {
        for (const lane of oportunidadesKanban) {
          await loadCardsKanban(
            1,
            10,
            "data_agendamento",
            "desc",
            lastSearch,
            lane,
          );
        }
      }
    }

    runLoadCards();
  }, [oportunidadesKanban]);

  useEffect(() => {
    if (!props.search && changeVisaoModeStartLoad) {
      loadOportunidades(
        currentPage,
        currentPerPage,
        currentSortField,
        currentSortOrder,
        lastSearch,
      );
    }
    setChangeVisaoModeStartLoad(true);
  }, [visaoMode]);

  function reloadOportunidades() {
    console.log("RELOAD OPORTUNIDADES");
    loadOportunidades(
      currentPage,
      currentPerPage,
      currentSortField,
      currentSortOrder,
      lastSearch,
    );
  }

  async function loadMensagensBaileys(oportunidade) {
    try {
      const oportunidadeId = oportunidade?.id || oportunidade;

      const { data } = await api.get(
        `/chat/oportunidade/${oportunidadeId}/conversation`,
      );

      const messages = Array.isArray(data) ? data : [];

      setMensagensBaileys(messages);
      setHasMoreBaileys(false);
      setBaileysPage(1);
    } catch (error) {
      console.error("Erro ao carregar conversas", error);
      setMensagensBaileys([]);
      setHasMoreBaileys(false);
    }
  }

  async function openChatForOpportunity(cardOrOp) {
    try {
      let op = cardOrOp;

      let vendedorId =
        op?.user_id || op?.usuario_id || op?.colaborador_id || op?.usuario?.id;

      if (!vendedorId || !op?.cliente_id) {
        const { data: opCompleta } = await api.get(
          `/common/empresas/${empresaSelecionada?.id}/oportunidades/${op.id}`,
        );
        op = opCompleta;
        vendedorId =
          op.user_id || op.usuario_id || op.colaborador_id || op?.usuario?.id;
      }

      if (!vendedorId) {
        notify(
          "warning",
          "Não encontrei o usuário responsável por essa oportunidade.",
        );
        return;
      }

      // 🔹 sempre zera antes de carregar a nova conversa
      setMensagensBaileys([]);
      setHasMoreBaileys(false);
      setBaileysPage(1);

      // extrai telefone do cliente para o panel de iniciar conversa
      const tel = (() => {
        if (op?.cliente?.telefones?.length > 0) {
          const t = op.cliente.telefones[0];
          return t.ddd ? `${t.ddd}${t.numero}` : t.numero;
        }
        if (Array.isArray(op?.telefones) && op.telefones.length > 0) {
          const t = op.telefones[0];
          return t.ddd ? `${t.ddd}${t.numero}` : t.numero;
        }
        const raw = String(op?.telefone || "").split(",")[0].trim();
        return /\d{7,}/.test(raw) ? raw : "";
      })();
      setOpChatTelefone(tel);

      setOpChatAtual(op);

      // carrega mensagens da oportunidade selecionada
      await loadMensagensBaileys(op, 1);

      setOpenChatModal(true);
    } catch (err) {
      console.error("Erro ao abrir chat da oportunidade", err);
      notify("danger", "Não foi possível abrir o chat da oportunidade.");
      // em erro, garante que não mostra conversa antiga
      setMensagensBaileys([]);
      setHasMoreBaileys(false);
    }
  }

  function openCopilotForOpportunity(card) {
    let oportunidade;

    if (card.laneId) {
      // Modo kanban — estagio vem do lane
      const lane = rLanes.find((l) => l.id == card.laneId);
      oportunidade = {
        ...card,
        estagio: lane?.title || "",
        user: card.colaborador || card.user || null,
      };
    } else {
      // Modo lista — estrutura diferente, normaliza os campos
      oportunidade = {
        ...card,
        title: card.cliente?.nome || card.title || "",
        anuncio: card.anuncio?.nome || "",
        campanha: card.anuncio?.campanha?.nome || "",
        estagio: card.estagio?.nome || "",
        tags: card.tags || "",
      };
    }

    setCopilotOportunidade(oportunidade);
    setOpenCopilot(true);
  }

  function notify(type, msg) {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span data-notify="message">{msg}</span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 7,
    };
    if (notificationAlert) notificationAlert.current.notificationAlert(options);
  }

  async function handleCriarCardFromOp(op) {
    setOpParaCard(op);
    if (funisPipeline.length === 0) {
      try {
        const res = await api.get(`/common/empresas/${empresaSelecionada?.id}/funis/?tipo=pipeline`);
        const data = res.data?.rows || res.data;
        setFunisPipeline(Array.isArray(data) ? data : []);
      } catch (e) {
        notify('danger', 'Falha ao carregar pipelines.');
        return;
      }
    }
    setShowCardModalFromOp(true);
  }

  async function handleVerCardsVinculados(op) {
    setOpParaCards(op);
    try {
      const res = await api.get(`/common/empresas/${empresaSelecionada?.id}/cards?entidade_tipo=oportunidade&entidade_id=${op.id}`);
      const data = res.data?.rows || res.data;
      setCardsVinculados(Array.isArray(data) ? data : []);
      setShowCardsListModal(true);
    } catch (e) {
      if (notify) notify('danger', 'Falha ao carregar cards vinculados.');
    }
  }

  function handleOpenOpSidebar(op) {
    setSelectedOpIdForSidebar(op.id);
    setShowOpDetailsSidebar(true);
  }

  async function handleVerDetalhesCard(card) {
    try {
      const res = await api.get(`/common/empresas/${empresaSelecionada?.id}/cards/${card.id}`);
      setSelectedCardForSidebar(res.data);
    } catch (e) {
      console.error(e);
      setSelectedCardForSidebar(card);
    }
    setShowCardDetailsSidebar(true);
  }

  function onNewClicked(e) {
    e.preventDefault();
    props.history.push("oportunidades/new");
  }

  async function updatePageProperties(response) {
    const { total, perPage, page, lastPage } = response.data;
    setPageProperties({
      ...pageProperties,
      total,
      perPage,
      page,
      lastPage,
      loading: false,
    });
  }

  async function loadCardsKanban(
    page = 1,
    limit = 10,
    sortField = "data_agendamento",
    sortOrder = "desc",
    filters = lastSearch,
    lane,
  ) {
    if (visaoMode == "kanban" && lane) {
      setLoading(true);

      try {
        setPageProperties({
          ...pageProperties,
          loading: true,
        });
        const cancelSource = Axios.CancelToken.source();
        cancelApi = cancelSource;
        const url = `common/empresas/${empresaSelecionada?.id}/oportunidadeskanban`;
        const response = await api.get(url, {
          cancelToken: cancelSource.token,
          params: {
            page,
            limit,
            sortField,
            sortOrder,
            ...filters,
            estagioLane: lane.id,
          },
        });

        const cards = response.data;

        setRLanes(() => {
          return oportunidadesKanban.map((op) => {
            if (op.id == lane.id) op.cards = cards;
            return op;
          });
        });
      } catch (err) {
        console.error(err);
        if (err.message === "Request canceled") return;
        notify("danger", "Houve um problema ao carregar as Oportunidades.");
      } finally {
        setLoading(false);
      }
    } else {
      notify("danger", "Falha no load da Visão Kanban (Validacao).");
    }
  }

  async function loadMoreCardsKanban(
    page = 0,
    limit = 10,
    sortField = "data_agendamento",
    sortOrder = "desc",
    filters = lastSearch,
    laneId = 0,
  ) {
    if (visaoMode == "kanban" && page && page > 0 && laneId && laneId > 0) {
      try {
        setPageProperties({
          ...pageProperties,
          loading: true,
        });
        const cancelSource = Axios.CancelToken.source();
        cancelApi = cancelSource;
        const url = `common/empresas/${empresaSelecionada?.id}/oportunidadeskanban`;
        const response = await api.get(url, {
          cancelToken: cancelSource.token,
          params: {
            page,
            limit,
            sortField,
            sortOrder,
            ...filters,
            estagioLane: laneId,
          },
        });

        const moreCards = response.data;

        return moreCards;
      } catch (err) {
        console.error(err);
        if (err.message === "Request canceled") return;
        notify("danger", "Houve um problema ao carregar as Oportunidades.");
        return [];
      }
    } else {
      notify("danger", "Falha no load da Visão Kanban (Validacao).");
      return [];
    }
  }

  async function loadOportunidades(
    page = 1,
    limit = 22,
    sortField = "data_agendamento",
    sortOrder = "desc",
    filters = lastSearch,
  ) {
    setLoading(true);
    setCurrentPage(page);
    setCurrentPerPage(limit);
    setCurrentSortField(sortField);
    setCurrentSortOrder(sortOrder);
    try {
      setPageProperties({
        ...pageProperties,
        loading: true,
      });
      const cancelSource = Axios.CancelToken.source();
      cancelApi = cancelSource;
      const url =
        visaoMode == "kanban"
          ? `common/empresas/${empresaSelecionada?.id}/estagioskanban`
          : `common/empresas/${empresaSelecionada?.id}/oportunidades`;
      const response = await api.get(url, {
        cancelToken: cancelSource.token,
        params: {
          page,
          limit,
          sortField,
          sortOrder,
          ...filters,
        },
      });

      if (visaoMode == "kanban") {
        setOportunidadesKanban(response.data);
      } else {
        setOportunidades(response.data);
      }

      updatePageProperties(response);

      if (funisPipeline.length === 0) {
        api.get(`/common/empresas/${empresaSelecionada?.id}/funis/?tipo=pipeline`)
          .then(res => {
            const data = res.data?.rows || res.data;
            setFunisPipeline(Array.isArray(data) ? data : []);
          })
          .catch(() => {});
      }
    } catch (err) {
      console.error(err);
      if (err.message === "Request canceled") return;
      notify("danger", "Houve um problema ao carregar as Oportunidades.");
    }
    setLoading(false);
  }

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder },
  ) => {
    try {
      if (type == "sort") {
        sortField = sortField.replace("__meta__.", "");
        const value = pageProperties.sort.get(sortField);
        const newOrder = (value || "asc") == "desc" ? "asc" : "desc";
        const map = pageProperties.sort;
        map.set(sortField, newOrder);
        sortOrder = newOrder;
        setCurrentSortField(sortField);
        setCurrentSortOrder(sortOrder);
      } else if (type == "pagination") {
        sortField = currentSortField;
        sortOrder = currentSortOrder;
      }
      if (cancelApi) {
        try {
          cancelApi.cancel("Request canceled");
        } catch (error) {}
      }
      loadOportunidades(
        page == 0 ? 1 : page,
        sizePerPage,
        sortField,
        sortOrder,
      );
    } catch (error) {
      notify("danger", "Houve um problema ao carregar as Oportunidades.");
    }
  };

  const handleNovaMalaDireta = async (e) => {
    e.preventDefault();
    const reference = uuidv1();

    await saveTemporaryRecipients(reference);

    props.history.push("malas-diretas/new/" + reference);
  };

  const saveTemporaryRecipients = async (reference) => {
    try {
      showMalaDiretaProgress();
      await api.post(
        `common/empresas/${empresaSelecionada?.id}/destinatarios-malas-diretas-temporarios`,
        {
          ...lastSearch,
          referencia_id: reference,
        },
      );
      await new Promise((resolver) => setTimeout(resolver, 1000));
      setAlert(null);
    } catch (error) {
      if (error.response && error.response.data.message) {
        notify("danger", error.response.data.message);
      } else {
        notify(
          "danger",
          "Houve um problema ao carregar os destinatários da mala direta.",
        );
      }
      setAlert(null);
      throw error;
    }
  };

  function showMalaDiretaProgress() {
    setAlert(
      <Modal
        className="modal-dialog-centered modal-primary"
        contentClassName="bg-gradient-primary"
        isOpen={true}
      >
        <div className="modal-header">
          <h6 className="modal-title" id="modal-title-notification">
            Mala Direta
          </h6>
        </div>
        <div className="modal-body">
          <div className="py-3 text-center">
            <i className="ni ni-bell-55 ni-3x" />
            <h4 className="heading mt-4 mb-4">Carregando Destinatários</h4>
            <p>
              <Spinner color="secondary" />
            </p>
          </div>
        </div>
      </Modal>,
    );
  }

  function handleEncaminharOportunidades() {
    setShowEncaminhamento(true);
  }
  function handleEncerrarOportunidades() {
    setShowEncerramento(true);
  }
  function handleReagendarOportunidades() {
    setShowReagendamento(true);
  }
  function handleAlterarEstagioOportunidades() {
    setShowAlterarEstagio(true);
  }

  function handleExportarOportunidades() {
    setShowExport(true);
  }

  function handleVerSumario() {
    setShowSumario(true);
  }

  function handleCriarRotaVisitas() {
    setShowRotasVisitas(true);
  }

  function onCloseRotasVisitas() {
    setShowRotasVisitas(false);
  }

  function handleVisualizarRotas() {
    setShowVisualizarRotas(true);
  }

  function onCloseVisualizarRotas() {
    setShowVisualizarRotas(false);
  }

  function handleGerenciarRotas() {
    setShowListagemRotas(true);
  }

  function onCloseListagemRotas() {
    setShowListagemRotas(false);
  }

  function handleVerDetalhesRota(rotaId) {
    setRotaIdSelecionada(rotaId);
    setShowListagemRotas(false);
    setShowDetalhesRota(true);
  }

  function onCloseDetalhesRota() {
    setShowDetalhesRota(false);
    setRotaIdSelecionada(null);
  }

  function handleVoltarParaListagem() {
    setShowDetalhesRota(false);
    setShowListagemRotas(true);
  }

  function onCloseEncaminhamento() {
    setShowEncaminhamento(false);
  }
  function onCloseEncerramento() {
    setShowEncerramento(false);
  }
  function onCloseReagendamento() {
    setShowReagendamento(false);
  }
  function onCloseAlterarEstagio() {
    setShowAlterarEstagio(false);
  }
  function onEncaminhamentoRealizado() {
    loadOportunidades();
  }
  function onReagendamentoRealizado() {
    loadOportunidades();
  }
  function onEncerramentoRealizado() {
    loadOportunidades();
  }
  function onAlterarEstagioRealizado() {
    loadOportunidades();
  }

  const AdditionalOptions = ({
    hasPermission,
    handleNovaMalaDireta,
    handleEncaminharOportunidades,
    handleEncerrarOportunidades,
    handleReagendarOportunidades,
    handleAlterarEstagioOportunidades,
    handleExportarOportunidades,
    handleVerSumario,
    handleCriarRotaVisitas,
  }) => {
    const [menu, setMenu] = useState([]);

    useEffect(() => {
      createDropMenus();
    }, []);

    function createDropMenus() {
      const menus = [];
      if (hasPermission("gerenciar-mala-direta")) {
        menus.push(
          <li key="gerenciar-mala-direta">
            <DropdownItem href="#" onClick={handleNovaMalaDireta}>
              <i className="fas fa-suitcase"></i>
              {"Nova mala direta"}
            </DropdownItem>
          </li>,
        );
      }
      if (hasPermission("encaminhar-todas-oportunidades")) {
        menus.push(
          <li key={"acoes-em-lote"}>
            <UncontrolledDropdown group direction="left">
              <DropdownToggle
                className="d-flex align-items-center"
                style={{ gap: "20px", fontWeight: "400" }}
              >
                <i className="fas fa-ellipsis-v"></i>
                {"Ações em lote"}
              </DropdownToggle>
              <DropdownMenu right>
                <DropdownItem href="#" onClick={handleEncaminharOportunidades}>
                  <i className="far fa-share-square"></i>
                  {"Encaminhar"}
                </DropdownItem>
                <DropdownItem
                  href="#"
                  onClick={(e) => {
                    handleEncerrarOportunidades();
                  }}
                >
                  <i className="far fa-window-close"></i>
                  {"Encerrar"}
                </DropdownItem>
                <DropdownItem
                  href="#"
                  onClick={(e) => handleReagendarOportunidades()}
                >
                  <i className="fas fa-calendar-alt"></i>
                  {"Reagendar"}
                </DropdownItem>
                <DropdownItem
                  href="#"
                  onClick={(e) => handleAlterarEstagioOportunidades()}
                >
                  <i className="fas fa-exchange-alt"></i>
                  {"Alterar Estágios"}
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>,
        );
      }
      if (hasRole("gestor_comercial") || hasRole("comercial_restritivo")) {
        menus.push(
          <li key={"exportar-oportunidades"}>
            <DropdownItem href="#" onClick={handleExportarOportunidades}>
              <i className="fas fa-file-export"></i>
              {"Exportar"}
            </DropdownItem>
          </li>,
        );
      }
      if (
        hasRole("administrador_empresa") ||
        hasRole("gestor_comercial") ||
        hasRole("comercial_restritivo")
      ) {
        menus.push(
          <li key={"ver-sumario"}>
            <DropdownItem href="#" onClick={handleVerSumario}>
              <i className="fas fa-eye"></i>
              {"Ver sumário"}
            </DropdownItem>
          </li>,
        );
      }

      // Adicionar opção de criar rota de visitas
      menus.push(
        <li key={"criar-rota-visitas"}>
          <DropdownItem href="#" onClick={handleCriarRotaVisitas}>
            <i className="fas fa-route"></i>
            {"Criar Rota de Visitas"}
          </DropdownItem>
        </li>,
      );

      // Adicionar opção de gerenciar rotas
      menus.push(
        <li key={"gerenciar-rotas"}>
          <DropdownItem href="#" onClick={handleGerenciarRotas}>
            <i className="fas fa-map-marked-alt"></i>
            {"Gerenciar Rotas"}
          </DropdownItem>
        </li>,
      );

      setMenu(menus);
    }

    return (
      <div style={{ display: "inline-flex", alignItems: "center" }}>
        {menu.length > 0 && (
          <UncontrolledDropdown group size="sm" direction="down">
            <DropdownToggle color="link">
              <i className="fas fa-ellipsis-v"></i>
            </DropdownToggle>
            <DropdownMenu right>{menu}</DropdownMenu>
          </UncontrolledDropdown>
        )}
      </div>
    );
  };

  return (
    <>
      {alert}
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlert} />
      </div>
      <Encerrar
        show={showEncerramento}
        onClose={onCloseEncerramento}
        onSuccess={onEncerramentoRealizado}
        lastSearch={lastSearch}
        notify={notify}
        oportunidades={oportunidades}
      />
      <Reagendar
        show={showReagendamento}
        onClose={onCloseReagendamento}
        oportunidades={oportunidades}
        onSuccess={onReagendamentoRealizado}
        lastSearch={lastSearch}
        notify={notify}
      />
      <EncaminharOportunidades
        show={showEncaminhamento}
        onClose={onCloseEncaminhamento}
        onSuccess={onEncaminhamentoRealizado}
        lastSearch={lastSearch}
        notify={notify}
        oportunidades={oportunidades}
      />
      <AlterarEstagio
        show={showAlterarEstagio}
        onClose={onCloseAlterarEstagio}
        onSuccess={onAlterarEstagioRealizado}
        notify={notify}
        oportunidades={oportunidades}
      />

      <Export
        show={showExport}
        onClose={() => setShowExport(false)}
        search={lastSearch}
        isConversao={false}
      />
      <Sumario
        show={showSumario}
        onClose={() => setShowSumario(false)}
        search={lastSearch}
        isConversao={false}
      />
      <SimpleHeader
        name="Listagem de oportunidades"
        parentName="Oportunidades"
        {...props}
      />
      <div className="">
        <Row>
          <Col>
            <Card>
              <CardHeader
                style={{
                  position: "sticky",
                  top: "0px",
                  zIndex: 200,
                  paddingBottom: "0px",
                }}
              >
                <Filters
                  {...props}
                  presetId={presetId}
                  title={
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <h1 style={{ margin: 0 }}>Oportunidades</h1>
                    </div>
                  }
                  // data={oportunidades}
                  load={(filters, clearPagination, clearSort) => {
                    setLastSearch(filters);
                    loadOportunidades(
                      clearPagination ? 1 : currentPage,
                      clearPagination ? 10 : currentPerPage,
                      clearSort ? "data_agendamento" : currentSortField,
                      clearSort ? "desc" : currentSortOrder,
                      filters,
                    );
                  }}
                  visaoMode={visaoMode}
                  setVisaoMode={setVisaoModeWithPersist}
                  notify={notify}
                  actions={
                    !readOnly ? (
                      <>
                        <Button
                          id="tooltip0983764373524743"
                          disabled={empresaSelecionada?.id == 0 ? true : false}
                          color="primary"
                          type="button"
                          onClick={(e) => onNewClicked(e)}
                          size="sm"
                        >
                          <span className="btn-inner--icon">
                            <i className="ni ni-fat-add" />
                          </span>{" "}
                          Nova oportunidade
                        </Button>
                        <AdditionalOptions
                          hasPermission={hasPermission}
                          oportunidades={oportunidades}
                          handleNovaMalaDireta={handleNovaMalaDireta}
                          handleEncaminharOportunidades={
                            handleEncaminharOportunidades
                          }
                          handleEncerrarOportunidades={
                            handleEncerrarOportunidades
                          }
                          handleReagendarOportunidades={
                            handleReagendarOportunidades
                          }
                          handleAlterarEstagioOportunidades={
                            handleAlterarEstagioOportunidades
                          }
                          handleExportarOportunidades={
                            handleExportarOportunidades
                          }
                          handleVerSumario={handleVerSumario}
                          handleCriarRotaVisitas={handleCriarRotaVisitas}
                        />
                      </>
                    ) : null
                  }
                />
                {empresaSelecionada?.id == 0 && (
                  <UncontrolledTooltip
                    delay={0}
                    placement="bottom"
                    target="tooltip0983764373524743"
                  >
                    Primeiro selecione uma empresa...
                  </UncontrolledTooltip>
                )}
              </CardHeader>
              <CardBody style={{ paddingTop: "0px" }}>
                <Row>
                  <Col></Col>
                </Row>
                <Row>
                  <Col>
                    {visaoMode == "kanban" ? (
                      <Kanban
                        readOnly={readOnly}
                        lanes={rLanes}
                        onChangeEstagioExterno={loadOportunidades}
                        handleLoadMoreCards={loadMoreCardsKanban}
                        lastSearch={lastSearch}
                        notify={notify}
                        history={props.history}
                        pageProperties={{ ...pageProperties, loading }}
                        loading={loading}
                        onOpenChatModal={(op) => openChatForOpportunity(op)}
                        onOpenCopilot={(op) => openCopilotForOpportunity(op)}
                        onOpenConverterModal={handleOpenConverterModal}
                        onOpenEncerrarModal={handleOpenEncerrarModal}
                        onCriarCard={handleCriarCardFromOp}
                        onVerCards={handleVerCardsVinculados}
                        onVerOportunidade={handleOpenOpSidebar}
                        hasPipeline={hasPipeline}
                      ></Kanban>
                    ) : (
                      <Table
                        keyField="id"
                        readOnly={readOnly}
                        oportunidades={oportunidades ? oportunidades.data : []}
                        notify={notify}
                        onTableChange={handleTableChange}
                        history={props.history}
                        pageProperties={{ ...pageProperties, loading }}
                        loading={loading}
                        isConversao={false}
                        reloadOportunidades={reloadOportunidades}
                        onOpenChatModal={(op) => openChatForOpportunity(op)}
                        onOpenCopilot={(op) => openCopilotForOpportunity(op)}
                        onCriarCard={handleCriarCardFromOp}
                        onVerCards={handleVerCardsVinculados}
                        onVerOportunidade={handleOpenOpSidebar}
                        onOpenConverterModal={handleOpenConverterModal}
                        onOpenEncerrarModal={handleOpenEncerrarModal}
                        hasPipeline={hasPipeline}
                      />
                    )}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      {/* Modal de Rotas de Visitas */}
      <RotasVisitas
        show={showRotasVisitas}
        onClose={onCloseRotasVisitas}
        oportunidades={oportunidades}
        notify={notify}
      />

      {/* Modal: CardModal com entidade vinculada e seletor de pipeline */}
      {showCardModalFromOp && (
        <CardModal
          key={`card-from-op-${opParaCard?.id}`}
          isOpen={showCardModalFromOp}
          toggle={() => { setShowCardModalFromOp(false); setOpParaCard(null); }}
          funis={funisPipeline}
          card={{
            titulo: opParaCard?.title || opParaCard?.nome || '',
            descricao: `Card criado a partir da oportunidade #${opParaCard?.id}`,
            entidade_tipo: 'oportunidade',
            entidade_id: opParaCard?.id,
          }}
          onSuccess={() => { setShowCardModalFromOp(false); setOpParaCard(null); }}
          notify={notify}
        />
      )}



      <Modal
        className="modal-dialog-centered modal-success"
        size="md"
        isOpen={showConverterModal}
        toggle={() => setShowConverterModal(false)}
      >
        <div className="modal-header">
          <h6 className="modal-title" id="modal-title-converter">
            Converter oportunidade
          </h6>
        </div>
        <div className="modal-body">
          <div className="py-3 text-center">
            <i
              className="fas fa-dollar-sign ni-3x"
              style={{ fontSize: "2rem" }}
            />
            <h4 className="heading mt-4"></h4>
            <p>
              Você está prestes a converter esta oportunidade. Deseja
              prosseguir?
            </p>
          </div>
        </div>
        <div className="modal-footer">
          <Button
            className="text-white ml-auto"
            color="link"
            type="button"
            onClick={() => setShowConverterModal(false)}
            disabled={isActionSaving}
          >
            Fechar
          </Button>
          <Button
            onClick={() => executeConverter()}
            className="btn-white"
            color="default"
            type="button"
            disabled={isActionSaving}
          >
            {isActionSaving && <Spinner size="sm" className="mr-2" />}
            Converter
          </Button>
        </div>
      </Modal>

      <Modal
        className="modal-dialog-centered modal-danger"
        size="md"
        isOpen={showEncerrarModal}
        toggle={() => setShowEncerrarModal(false)}
      >
        <div className="modal-header">
          <h6 className="modal-title" id="modal-title-notification">
            Encerrar oportunidade
          </h6>
        </div>
        <div className="modal-body">
          <div className="py-3 text-center">
            <i
              className="fas fa-exclamation-circle ni-3x"
              style={{ fontSize: "2rem" }}
            />
            <h4 className="heading mt-4"></h4>
            <p>
              Você está prestes a encerrar esta oportunidade. Selecione um
              motivo de encerramento para prosseguir.
            </p>
            <FormGroup>
              <Select2
                className="form-control"
                onSelect={(e) => setEncerramentoId(e.target.value)}
                options={{
                  placeholder: "Selecione um motivo encerramento...",
                }}
                value={encerramentoId}
                data={encerramentos.map((item) => ({
                  id: item.id,
                  text: item.nome,
                }))}
              />
            </FormGroup>
          </div>
        </div>
        <div className="modal-footer">
          <Button
            className="text-white ml-auto"
            color="link"
            type="button"
            onClick={() => setShowEncerrarModal(false)}
            disabled={isActionSaving}
          >
            Fechar
          </Button>
          <Button
            onClick={() => executeEncerrar()}
            className="btn-white"
            color="default"
            type="button"
            disabled={isActionSaving}
          >
            {isActionSaving && <Spinner size="sm" className="mr-2" />}
            Encerrar
          </Button>
        </div>
      </Modal>

      {/* Modal de Visualizar Rotas */}
      <VisualizarRotas
        show={showVisualizarRotas}
        onClose={onCloseVisualizarRotas}
        notify={notify}
      />

      {/* Modal de Listagem de Rotas (R04) */}
      <ListagemRotas
        show={showListagemRotas}
        onClose={onCloseListagemRotas}
        notify={notify}
        onVerDetalhes={handleVerDetalhesRota}
      />

      {/* Modal de Detalhes da Rota (R05) */}
      <DetalhesRota
        show={showDetalhesRota}
        onClose={onCloseDetalhesRota}
        rotaId={rotaIdSelecionada}
        notify={notify}
        onVoltar={handleVoltarParaListagem}
      />
      <ChatModal
        isOpen={openChatModal}
        onClose={() => setOpenChatModal(false)}
        modalClassName="drawer-modal"
        messages={mensagensBaileys}
        hasMore={hasMoreBaileys}
        onLoadMore={async () =>
          loadMensagensBaileys(opChatAtual, baileysPage + 1)
        }
        onMensagemEnviada={async () => loadMensagensBaileys(opChatAtual, 1)}
        telefoneCliente={opChatTelefone}
      />
      <CopilotSidebar
        isOpen={openCopilot}
        onClose={() => setOpenCopilot(false)}
        oportunidade={copilotOportunidade}
      />
      <CardsSidebar
        isOpen={showCardsListModal}
        onClose={() => setShowCardsListModal(false)}
        oportunidade={opParaCards}
        cards={cardsVinculados}
        onCardClick={handleVerDetalhesCard}
      />

      {showOpDetailsSidebar && (
        <>
          <div className="copilot-backdrop" onClick={() => setShowOpDetailsSidebar(false)} />
          <div className="copilot-drawer" style={{ width: '70%', maxWidth: '100vw' }}>
            {/* Header */}
            <div className="copilot-header">
              <div className="copilot-header-info" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px' }}>
                <h3 className="copilot-header-title">Detalhes da Oportunidade</h3>
                {selectedOpIdForSidebar && (
                  <a
                    href={`/admin/oportunidades/${selectedOpIdForSidebar}/edit`}
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Abrir em nova guia"
                    style={{ color: '#adb5bd', lineHeight: 1, display: 'flex' }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                      <polyline points="15 3 21 3 21 9" />
                      <line x1="10" y1="14" x2="21" y2="3" />
                    </svg>
                  </a>
                )}
              </div>
              <button className="copilot-close-btn" onClick={() => setShowOpDetailsSidebar(false)} aria-label="Fechar">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>
            {/* Body */}
            <div className="copilot-body" style={{ overflowY: 'auto', padding: 0 }}>
              {selectedOpIdForSidebar && (
                <OportunidadesForm
                  oportunidadeId={selectedOpIdForSidebar}
                  readOnly={undefined}
                  oportunidadeIdToCrossSelling={undefined}
                  tipoCrossSelling={undefined}
                  coordenadas={undefined}
                  onClose={() => setShowOpDetailsSidebar(false)}
                />
              )}
            </div>
          </div>
        </>
      )}

      {showCardDetailsSidebar && (
        <>
          <div className="copilot-backdrop" onClick={() => setShowCardDetailsSidebar(false)} style={{ zIndex: 1060 }} />
          <div className="copilot-drawer" style={{ width: '500px', maxWidth: '100vw', zIndex: 1061 }}>
            {/* Header */}
            <div className="copilot-header">
              <div className="copilot-header-info">
                <h3 className="copilot-header-title">Detalhes do Card</h3>
              </div>
              <button className="copilot-close-btn" onClick={() => setShowCardDetailsSidebar(false)} aria-label="Fechar">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>
            {/* Body */}
            <div className="copilot-body" style={{ overflowY: 'auto', padding: '1rem' }}>
              {selectedCardForSidebar && (
                <CardForm
                  key={selectedCardForSidebar.id}
                  card={selectedCardForSidebar}
                  funilId={selectedCardForSidebar.funil_id}
                  onSuccess={() => {
                    setShowCardDetailsSidebar(false);
                    if (opParaCards) handleVerCardsVinculados(opParaCards);
                  }}
                  onCancel={() => setShowCardDetailsSidebar(false)}
                  notify={notify}
                />
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
}
